export function IsBijlageFieldAndHasAtleastOneFile(fieldValue: {}): fieldValue is FileList {
  const fileList = fieldValue as FileList;
  if (!fileList) {
    return false;
  }

  if (typeof fieldValue !== "object") {
    return false;
  }

  if (!("length" in fileList)) {
    return false;
  }

  if (Array.isArray(fileList) && fileList.every((item) => typeof item === "string")) {
    return false;
  }

  return fileList.length > 0 && "name" in fileList[0];
}
